import { render, staticRenderFns } from "./PeopleView.vue?vue&type=template&id=247a01f9&scoped=true&"
import script from "./PeopleView.vue?vue&type=script&setup=true&lang=js&"
export * from "./PeopleView.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PeopleView.vue?vue&type=style&index=0&id=247a01f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247a01f9",
  null
  
)

export default component.exports